import { inject, Injectable } from '@angular/core';
import {
  ApiResponse,
  PartsAssemblyDTO,
  PartsLeakCheckDTO,
  PartsPositionCheckImageDTO,
  PartsSummaryDTO,
  ScannedItem,
  SingleItem,
} from '@interfaces';
import { delay, Observable, of } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PartsService {
  private readonly _apiPath = 'single-items';
  private readonly _api = inject(ApiService);

  getPartById(id: string) {
    return this._api.get<PartsSummaryDTO>(`${this._apiPath}/${id}`);
  }

  getPartPositionCheckImages(id: string) {
    return this._api.get<PartsPositionCheckImageDTO[]>(
      `${this._apiPath}/${id}/position-check-images`,
    );
  }

  getPartLeakCheck(id: string) {
    return this._api.get<PartsLeakCheckDTO[]>(
      `${this._apiPath}/${id}/leak-check`,
    );
  }

  getAssembly(id: string) {
    return this._api.get<PartsAssemblyDTO[]>(`${this._apiPath}/${id}/assembly`);
  }

  getSingleItemsByProductionOrder(id: string) {
    return this._api.get<PartsSummaryDTO[]>(
      `production-orders/${id}/single-items`,
    );
  }

  getPartsByArticle(
    articleId?: string,
    batchId?: string,
  ): Observable<ApiResponse<SingleItem[]>> {
    return this._api.get<SingleItem[]>(
      `${this._apiPath}/article/${articleId}/batch/${batchId}`,
    );
  }

  getScannedItems(
    singleItemId: string,
  ): Observable<ApiResponse<ScannedItem[]>> {
    return this._api.get<ScannedItem[]>(
      `${this._apiPath}/${singleItemId}/equipments`,
    );
  }

  getProcessInformation(partId: string) {
    console.info('getProcessInformation', partId);
    return of({
      data: {
        partId: 'EE30815F-03AB-44A9-A8AB-7D06BAFED4CD',
        batchId: '1',
        externalArticleId: '123',
        processTypes: [
          {
            type: 'Assembly',
            image: 'https://placehold.co/600x400',
            description: `<!DOCTYPE html>
                            <html lang="en">
                              <head>
                                <meta charset="UTF-8">
                                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                                <title>Basic HTML Document</title>
                              </head>
                              <body>
                                <h1>Hello, World!</h1>
                                <p>This is a basic HTML document.</p>
                              </body>
                            </html>`,
          },
          {
            type: 'Extrusion',
            image: 'https://placehold.co/600x400',
            description: null,
          },
        ],
      },
    }).pipe(delay(2000));

    // return this._api.get<ProcessInformation>(
    //   `${this._apiPath}/${partId}/process-information`,
    // );
  }
}
